// extracted by mini-css-extract-plugin
module.exports = {"link":"pagination_link__vZZbl","item":"pagination_item__2WrQ7","activeLink":"pagination_activeLink__2bTwM"};